import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the filter messages view.
 * @extends JetView
 */
export default class FilterMessagesView extends JetView {
    /**
     * Configures the UI components of the filter messages view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        // Left section containing input fields for filtering messages
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Input for Message Id
                            name: 'Id',
                            type: 'number',
                            label: "<span class='icon-id'></span>" + _('Mensaje Id'),
                            labelPosition: 'top',
                            placeholder: _('Mensaje Id'),
                            invalidMessage: _('Mensaje Id is required'),
                        },
                        {
                            view: 'text', // Input for Title
                            name: 'Title',
                            label: _('Título'),
                            labelPosition: 'top',
                            placeholder: _('Título'),
                            invalidMessage: _('Nombre is required'),
                        },
                        {
                            view: 'richselect', // Dropdown for Read status
                            name: 'Read',
                            label: _('Leido?'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: '1', value: _('Si') },
                                { id: '0', value: _('No') },
                            ],
                        },
                        {
                            view: 'combo', // Dropdown for Type
                            labelPosition: 'top',
                            label: _('Tipo'),
                            name: 'Type',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '0', value: _('Mensaje') },
                                { id: '1', value: _('Pop Up') },
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Input for Client Id From
                            name: 'ClientIdFrom',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('Emisor'),
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'),
                        },
                        {
                            view: 'text', // Input for Client Id To
                            name: 'ClientIdTo',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('Receptor'),
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'),
                        },
                        {
                            view: 'combo', // Dropdown for User Network type
                            labelPosition: 'top',
                            label: _('Tipo de red'),
                            name: 'UserNetwork',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '0', value: _('Punto de venta') },
                                { id: '1', value: _('Concesionario') },
                                { id: '2', value: _('Subconcesionario') },
                            ],
                        },
                        { gravity: 1 }, // Flexible space
                    ],
                },
            ],
        };

        // Upper section containing the left section
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 230 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };

        // Button section for actions
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 1 }, // Flexible space
                        {
                            minWidth: 200,
                            view: 'button', // Button to add message
                            value: _('Añadir Mensaje'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 150,
                            hidden: !devConfig.getPermAction('messageListAdd', 'Add'), // Conditional visibility
                            css: 'prm-messageListAdd',
                            click: () => {
                                this.app.callEvent('addMessage:button', [[]]); // Event to add message
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button', // Button to clear form
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            click: () => {
                                this.getRoot().clear(); // Clear form values
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button', // Button to consult messages
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 150,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('messages:filter', [filterdata]); // Event to filter messages
                                $$('b1').collapse(); // Collapse filter section
                                $$('a5').scrollTo(100, 0); // Scroll to specific position
                            },
                        },
                    ],
                },
            ],
        };

        // Second button section for actions
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Button to add message
                    value: _('Añadir'),
                    type: 'form',
                    hidden: !devConfig.getPermAction('messageListAdd', 'Add'), // Conditional visibility
                    css: 'prm-messageListAdd',
                    click: () => {
                        this.app.callEvent('addMessage:button', [[]]); // Event to add message
                    },
                },
                {
                    view: 'button', // Button to clear form
                    value: _('Limpiar'),
                    click: () => {
                        this.getRoot().clear(); // Clear form values
                    },
                },
                {
                    view: 'button', // Button to consult messages
                    value: _('Consultar'),
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get form values
                        this.app.callEvent('messages:filter', [filterdata]); // Event to filter messages
                        $$('filterPopup').hide(); // Hide filter popup
                    },
                },
            ],
        };

        // Accordion section containing filters
        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for filters
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        // Scrollable accordion section
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Upper section
            },
        };

        // Popup window for filters
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Title of the popup
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide popup on close
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });

        // Main form configuration
        return {
            view: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section1 // Show accordion section if screen size is sufficient
                    : { height: 1, width: 0 }, // Placeholder for small screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view after it is rendered.
     * @param {Object} grid - The grid object passed to the init method.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                // Additional initialization for small screens can be added here
            }
        });
    }
}

// FILE DOCUMENTED
